import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// SECTION: AUTH THUNKS

// NOTE: Admin Signin
export const signinAdmin = createAsyncThunk(
  "auth/admin/signin",
  async (data) => {
    const response = await api.post("auth/admin/signin", data);
    return response.data;
  }
);

// NOTE: Reset Default Password
export const resetDefaultPassword = createAsyncThunk(
  "auth/admin/resetDefaultPassword",
  async(data) => {
    const response = await api.post("auth/admin/reset-default-password", data);
    return response.data;
  }
)

// NOTE: Admin Forgot Password
export const forgotPasswordAdmin = createAsyncThunk(
  "auth/admin/forgot-password",
  async (data) => {
    const response = await api.post("auth/admin/forgot-password", data);
    return response.data;
  }
);

// NOTE: Admin Validate Reset Token
export const validateAdminToken = createAsyncThunk(
  "auth/admin/validate/token",
  async ({ id, token }) => {
    const response = await api.get(`auth/admin/verify-forgot//${id}/${token}`);
    return response.data;
  }
);

// NOTE: Admin Set New Password
export const updateAdminPassword = createAsyncThunk(
  "auth/admin/update/password",
  async ({ id, token, data }) => {
    const response = await api.post(
      `auth/admin/change-forgot-password/${id}/${token}`,
      data
    );
    return response.data;
  }
);

// NOTE: Change Admin Password
export const changeAdminPassword = createAsyncThunk(
  "auth/admin/changeAdminPassword",
  async (data) => {
    const response = await api.post(
      `auth/admin/change-password`,
      data
    );
    return response.data;
  }
);